import { ClientBillingAccountDto } from './clients/billingsAccounts.dto';

export class UserClientSummaryDto {
  id: number;
  name: string;
  parent: number | null;

  constructor(data: any = {}) {
    this.id = data.id ?? 0;
    this.name = data.name ?? '';
    this.parent = data.parent ?? null;
  }

  static fromJson(json: any): UserClientSummaryDto {
    return new UserClientSummaryDto(json);
  }

  toJson(): any {
    return {
      id: this.id,
      name: this.name,
      parent: this.parent
    };
  }
}

export class ClientTreeNodeDto {
  id: number;
  name: string;
  children: ClientTreeNodeDto[];

  constructor(data: any = {}) {
    this.id = data.id ?? 0;
    this.name = data.name ?? '';
    this.children = Array.isArray(data.children)
      ? data.children.map((child: any) => new ClientTreeNodeDto(child))
      : [];
  }

  static fromJson(json: any): ClientTreeNodeDto {
    return new ClientTreeNodeDto(json);
  }

  toJson(): any {
    return {
      id: this.id,
      name: this.name,
      children: this.children.map(child => child.toJson())
    };
  }
}

export class UserClientEntityDto {
  id: number;
  username: string;
  email: string;
  phone: string;
  name: string;
  last_name: string;
  image: string | null;
  is_active: boolean;
  is_superadmin: boolean;
  new_transport_notification: boolean;
  driver_assigned_notification: boolean;
  transport_finished_notification: boolean;
  cancelled_transport_notification: boolean;
  notify_client_users: boolean;
  notify_subclient_users: boolean;
  client_group_id: number;
  client_group_name: string;
  emails_to_notify: string[];
  clients: UserClientSummaryDto[];
  billing_accounts: ClientBillingAccountDto[];
  client_tree: ClientTreeNodeDto[];

  constructor(data: any = {}) {
    this.id = data.id ?? 0;
    this.username = data.username ?? '';
    this.email = data.email ?? '';
    this.phone = data.phone ?? '';
    this.name = data.name ?? '';
    this.last_name = data.last_name ?? '';
    this.image = data.image ?? null;
    this.is_active = data.is_active ?? false;
    this.is_superadmin = data.is_superadmin ?? false;
    this.new_transport_notification = data.new_transport_notification ?? false;
    this.driver_assigned_notification = data.driver_assigned_notification ?? false;
    this.transport_finished_notification = data.transport_finished_notification ?? false;
    this.cancelled_transport_notification = data.cancelled_transport_notification ?? false;
    this.notify_client_users = data.notify_client_users ?? false;
    this.notify_subclient_users = data.notify_subclient_users ?? false;
    this.client_group_id = data.client_group_id ?? 0;
    this.client_group_name = data.client_group_name ?? "";
    this.emails_to_notify = Array.isArray(data.emails_to_notify) ? data.emails_to_notify : [];
    this.clients = Array.isArray(data.clients)
      ? data.clients.map((client: any) => new UserClientSummaryDto(client))
      : [];
    this.billing_accounts = Array.isArray(data.billing_accounts)
      ? data.billing_accounts.map((account: any) => ClientBillingAccountDto.fromJson(account))
      : [];
    this.client_tree = Array.isArray(data.client_tree)
      ? data.client_tree.map((node: any) => new ClientTreeNodeDto(node))
      : [];
  }

  static fromJson(json: any): UserClientEntityDto {
    return new UserClientEntityDto(json);
  }

  toJson(): any {
    return {
      id: this.id,
      username: this.username,
      email: this.email,
      phone: this.phone,
      name: this.name,
      last_name: this.last_name,
      image: this.image,
      is_active: this.is_active,
      is_superadmin: this.is_superadmin,
      new_transport_notification: this.new_transport_notification,
      driver_assigned_notification: this.driver_assigned_notification,
      transport_finished_notification: this.transport_finished_notification,
      cancelled_transport_notification: this.cancelled_transport_notification,
      notify_client_users: this.notify_client_users,
      notify_subclient_users: this.notify_subclient_users,
      client_group_id: this.client_group_id,
      client_group_name: this.client_group_name,
      emails_to_notify: this.emails_to_notify,
      clients: this.clients.map(client => client.toJson()),
      billing_accounts: this.billing_accounts.map(account => account.toJson()),
      client_tree: this.client_tree.map(node => node.toJson())
    };
  }
}
